import { configureStore } from '@reduxjs/toolkit';
import occupationImobiliariaSlice from './real-state-slice';

export const store = configureStore({
  reducer: {
    occupationImobiliaria: occupationImobiliariaSlice
  },
});
